const fakeData = [
    {
        id : 1,
        // img : 'https://i.ibb.co/09S8bgb/achieevements2.png',
        num : '700+',
        title : 'Happy Clients'
    },
    {
        id : 2,
        img : 'https://i.ibb.co/09S8bgb/achieevements2.png',
        num : '140+',
        title : 'Projects Completed'
    },
    {
        id : 3,
        img : 'https://i.ibb.co/gVWbvCH/achieevements3.png',
        num : '25+',
        title : 'Crazy Minds'
    },
    {
        id : 4,
        img : 'https://i.ibb.co/vvwFRYZ/achieevements4.png',
        num : '75+',
        title : 'Running Projects'
    },
]

export default fakeData;